// extracted by mini-css-extract-plugin
export var errorIcon = "_lf-1";
export var nameLogo = "_lf-0";